export default "__VITE_ASSET__CTpMBvqq__"